import { Box, Typography, Paper } from '@mui/material';
import { brandGradient } from '../../shared-theme/themePrimitives';

const MessageBubble = ({ sender, text, children }) => {
    const isBot = sender === 'bot';
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: isBot ? 'flex-start' : 'flex-end',
                mt: 1
            }}
        >
            <Paper
                variant={isBot ? 'outlined' : 'elevation'}
                sx={{
                    p: 1.5,
                    borderRadius: 2.5,
                    maxWidth: '80%',
                    ...(isBot
                        ? { bgcolor: 'background.paper', color: 'text.primary' }
                        : { background: brandGradient, color: '#fff' }),
                }}
            >
                {text && <Typography variant="body2">{text}</Typography>}
                {children}
            </Paper>
        </Box>
    );
};

export default MessageBubble;
